// Storage key shared with the native Android FMS service that writes events.
// Spec: https://stuzo.atlassian.net/wiki/x/AgC9RwU (`push_notification_events`).
export const PUSH_NOTIFICATION_EVENTS_STORAGE_KEY = 'push_notification_events';

// Drop processed events from storage once they are older than this — protects
// the SharedPreferences blob from growing unbounded if the JS flush keeps running
// but the future cleanup ticket never lands.
export const PROCESSED_EVENT_RETENTION_MS = 30 * 24 * 60 * 60 * 1000;
